import * as writeOff from '../services/writeOff';

export default {
  namespace: 'writeOff',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
    allTotal: 0,
  },

  effects: {
    *queryDirectMarketMemberPage({ payload: { values } }, { call, put }) {
      const response = yield call(
        writeOff.queryDirectMarketMemberPage,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          memberPageList: response?.data,
          allTotal: response?.data?.total,
        },
      });
    },
    *consumeCode({ payload: { values }, callback }, { call }) {
      const response = yield call(
        writeOff.consumeCode,
        values,
      );
      callback(response);
    },
    *cancelConsume({ payload: { values }, callback }, { call }) {
      const response = yield call(
        writeOff.cancelConsume,
        values,
      );
      callback(response);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
